export default __webpack_public_path__ + "static/media/card.f2d9b1c3.svg";